// extracted by mini-css-extract-plugin
module.exports = {"pageBanners":"style-module_pageBanners__l1g6TQEmAWVa6echiuGCk","warning":"style-module_warning__3cOiFGIwzPNEA4gjW-hm3q"};